import { ExperimentFeatureFlagKey } from './devcycle-variables'

export type ExperimentDetails = {
  key: ExperimentFeatureFlagKey
  name: string
  description?: string
}

// Experiment config added here to track on GA
export const EXPERIMENTS: Array<ExperimentDetails> = [
  {
    key: 'hotel-card-cta',
    name: 'Hotel Card CTA',
  },
  {
    key: 'hotel-location-search-ordering',
    name: 'Hotel Location Search Ordering',
  },
  {
    key: 'popular-destinations',
    name: 'Hotel Location Search Popular Destinations',
  },
  {
    key: 'hotel-share-button',
    name: 'Hotel Share Button',
  },
  {
    key: 'hotel-upgrade-on-payment-options',
    name: 'Hotel Upgrade on Payment',
  },
]

export const getExperimentFlagDetails = (key: ExperimentFeatureFlagKey) => {
  return EXPERIMENTS.find((config) => config.key === key)
}
